import * as React from 'react';
import { useRouterState } from '@tanstack/react-router';

/**
 * Krok PRU1 — „Ukaž mi" = PRECHOD + JEMNE ZVYRAZNENI.
 *
 * Karta pruvodce (`guide-card.tsx`) vede na cilovou obrazovku s hashem
 * `#pruvodce-<krok>`. Tahle komponenta je v shellu JEDNOU pro cely admin:
 * pocka, az se cil oznaceny `data-guide="<krok>"` vykresli (obrazovky
 * nacitaji data), posune ho do zorneho pole a na par sekund ho obtahne
 * (`.rh-guide-highlight` v `ux-v4.css`). Nic neodskrtava — to dela az
 * skutecna akce makléře.
 */
export const GUIDE_HASH_PREFIX = 'pruvodce-';
const POLL_MS = 150;
/** Kolikrat se cil hleda (~6 s), nez se to vzda. */
const MAX_POLLS = 40;
const HIGHLIGHT_MS = 4000;
const HIGHLIGHT_CLASS = 'rh-guide-highlight';

/** Krok z hashe (`pruvodce-report` → `report`), jinak `null`. */
export function guideStepFromHash(hash: string): string | null {
  const clean = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!clean.startsWith(GUIDE_HASH_PREFIX)) return null;
  const step = clean.slice(GUIDE_HASH_PREFIX.length);
  return /^[a-z]+$/.test(step) ? step : null;
}

export function GuideHighlight(): null {
  const hash = useRouterState({ select: (s) => s.location.hash });
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  React.useEffect(() => {
    const step = guideStepFromHash(hash);
    if (step === null || typeof document === 'undefined') return;
    let highlighted: Element | null = null;
    let removeTimer: ReturnType<typeof setTimeout> | undefined;
    let polls = 0;
    const poll = setInterval(() => {
      const target = document.querySelector(`[data-guide="${step}"]`);
      if (target === null) {
        polls += 1;
        if (polls >= MAX_POLLS) clearInterval(poll);
        return;
      }
      clearInterval(poll);
      highlighted = target;
      if (typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      target.classList.add(HIGHLIGHT_CLASS);
      removeTimer = setTimeout(() => target.classList.remove(HIGHLIGHT_CLASS), HIGHLIGHT_MS);
    }, POLL_MS);
    return () => {
      clearInterval(poll);
      if (removeTimer !== undefined) clearTimeout(removeTimer);
      highlighted?.classList.remove(HIGHLIGHT_CLASS);
    };
  }, [hash, pathname]);
  return null;
}
